import classNames from 'classnames'

interface IProps {
  bgClasses: string
  bgSecondaryClasses: string
}

export const OrderListCardSmSkeleton: React.FC<IProps> = (props) => {
  const { bgClasses, bgSecondaryClasses } = props

  return (
    <div className={classNames('flex items-center justify-start gap-[10px] animate-pulse')}>
      <div className={classNames('w-[3px] h-[80%] rounded-[3px]', bgClasses)} />
      <div className={classNames('grow p-4 rounded-2xl overflow-hidden hover:cursor-pointer hover:opacity-80', bgClasses)}>
        <div className='flex items-center justify-between'>
          <div className='grow'>
            <div className='flex items-center justify-start mb-[10px] gap-[5px]'>
              <div className={classNames('w-[15px] h-[15px] min-w-[15px] min-h-[15px] rounded-[7.5px]', bgSecondaryClasses)} />
              <div className={classNames('h-[1em] w-[50%] rounded-3xl', bgSecondaryClasses)} />
            </div>
            <div className={classNames('ml-[20px] h-[1rem] w-[60%] rounded-3xl', bgSecondaryClasses)} />
          </div>
          <div className={classNames('rounded-3xl h-[1.3rem] w-[25%]', bgSecondaryClasses)} />
        </div>
      </div>
    </div>
  )
}
